<template>
  <nav class="navbar header is-white is-fixed-top" role="navigation" aria-label="main navigation">
    <div class="container">
      <div class="navbar-brand">
        <div class="navbar-item">
          <router-link class="navbar-item" :to="{ name: 'home' }">
            <img src="../../assets/logo.png" />
            <b class="is-size-6" style=" padding-top:5px;">{{ $t('title.onlineInternalAudit') }}</b>
          </router-link>
        </div>
        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
          @click="isOpen = !isOpen"
          v-bind:class="{ 'is-active': isOpen }"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample" class="navbar-menu" v-bind:class="{ 'is-active': isOpen }">
        <div class="navbar-start"></div>

        <div class="navbar-end">
          <div class="navbar-item">
            <div class="buttons">
              <router-link class="button is-text" :to="{ name: 'pricing' }">
                <strong>{{ $t('button.pricing') }}</strong>
              </router-link>
            </div>
          </div>
          <div class="navbar-item" v-if="!isAuthenticated">
            <div class="buttons">
              <router-link class="button is-primary" :to="{ name: 'signup' }">
                <strong>{{ $t('button.tryNow') }}</strong>
              </router-link>
              <router-link class="button is-light" :to="{ name: 'login' }">
                <strong>{{ $t('button.login') }}</strong>
              </router-link>
            </div>
          </div>
          <!-- <div class="navbar-item" v-if="isAuthenticated && role.limited">
            <router-link class="button is-success" :to="{ name: 'payment' }">
              <span>{{ $tc('button.goToPremium') }}</span>
            </router-link>
          </div>-->
          <div class="navbar-item" v-if="isAuthenticated">
            <a @click="onClickProcess" class="button is-primary">
              <strong>{{ $t('button.selectProcess') }}</strong>
            </a>
          </div>
          <div class="navbar-item has-dropdown is-hoverable" v-if="isAuthenticated">
            <a class="navbar-link">{{ currentUser.firstname }} {{ currentUser.lastname }}</a>
            <div
              class="navbar-dropdown is-right"
              v-bind:style="{ maxHeight: navbarMaxHeight + 'px', overflow: 'auto' }"
            >
              <span class="navbar-item">
                <b-button type="is-dark" expanded v-if="role.admin">{{
                  $t('title.admin')
                }}</b-button>
                <b-button type="is-info" expanded v-else-if="currentUser.parentCompanyId">
                  {{ currentUser.parentCompany }}
                </b-button>
                <b-button type="is-info" expanded v-else-if="role.company">
                  {{ currentUser.company }}
                </b-button>
                <b-button type="is-warning" expanded v-else-if="role.limited">{{
                  $t('title.limited')
                }}</b-button>
                <b-button type="is-success" expanded v-else>{{
                  $t('title.premiumSignup')
                }}</b-button>
              </span>
              <span class="navbar-item">
                <b>{{ $t('title.myReports') }}</b>
              </span>
              <router-link class="navbar-item" :to="{ name: 'reportScoreboard' }">
                <span class="icon is-medium">
                  <i class="fas fa-chart-pie"></i>
                </span>
                <span>{{ $tc('title.scoreboard') }}</span>
              </router-link>
              <router-link class="navbar-item" :to="{ name: 'reportQuestionsAnswers' }">
                <span class="icon is-medium">
                  <i class="fas fa-list-ul"></i>
                </span>
                <span>{{ $tc('title.reportQuestionsAnswers') }}</span>
              </router-link>
              <router-link class="navbar-item" :to="{ name: 'reportHistorical' }">
                <span class="icon is-medium">
                  <i class="fas fa-chart-bar"></i>
                </span>
                <span>{{ $tc('title.historicalScoreboard') }}</span>
              </router-link>
              <div v-if="role.company">
                <hr class="navbar-divider" />
                <span class="navbar-item">
                  <b>{{ $t('title.company') }}</b>
                </span>
                <router-link
                  v-if="!isProcessGroupPointCompany"
                  class="navbar-item"
                  :to="{ name: 'reportCompanyScoreCompare' }"
                >
                  <span class="icon is-medium">
                    <i class="fas fa-chart-bar"></i>
                  </span>
                  <span>{{ $tc('title.scoreCompare') }}</span>
                </router-link>
                <router-link
                  v-if="!isProcessGroupPointCompany"
                  class="navbar-item"
                  :to="{ name: 'reportCompanyAnswerCompare' }"
                >
                  <span class="icon is-medium">
                    <i class="fas fa-chart-bar"></i>
                  </span>
                  <span>{{ $tc('title.answerCompare') }}</span>
                </router-link>
                <router-link
                  v-if="role.companyDepartmentManagement"
                  class="navbar-item"
                  :to="{ name: 'companyDepartment' }"
                >
                  <span class="icon is-medium">
                    <i class="fas fa-sitemap"></i>
                  </span>
                  <span>{{ $t('title.department') }} {{ $t('title.edit') }}</span>
                </router-link>
              </div>
              <div v-if="role.admin || role.companyManagement || role.companyProcessCreate">
                <hr class="navbar-divider" />
                <span class="navbar-item">
                  <b>{{ $t('title.admin') }}</b>
                </span>
                <router-link
                  class="navbar-item"
                  :to="{ name: 'adminProcess' }"
                  v-if="role.admin || role.companyProcessCreate"
                >
                  <span class="icon is-medium">
                    <i class="fas fa-edit"></i>
                  </span>
                  <span>{{ $t('title.process') }} {{ $t('title.edit') }}</span>
                </router-link>
                <router-link
                  class="navbar-item"
                  :to="{ name: 'adminCompany' }"
                  v-if="role.companyManagement"
                >
                  <span class="icon is-medium">
                    <i class="fas fa-building"></i>
                  </span>
                  <span>{{ $t('title.company') }} {{ $t('title.edit') }}</span>
                </router-link>
                <router-link class="navbar-item" :to="{ name: 'adminUser' }" v-if="role.admin">
                  <span class="icon is-medium">
                    <i class="fas fa-users"></i>
                  </span>
                  <span>{{ $t('title.adminUser') }}</span>
                </router-link>
                <router-link class="navbar-item" :to="{ name: 'adminDiscount' }" v-if="role.admin">
                  <span class="icon is-medium">
                    <i class="fas fa-money-check-alt"></i>
                  </span>
                  <span>{{ $t('title.adminDiscount') }}</span>
                </router-link>
                <router-link
                  v-if="role.admin"
                  class="navbar-item"
                  :to="{ name: 'adminReportExport' }"
                >
                  <span class="icon is-medium">
                    <i class="fas fa-file-download"></i>
                  </span>
                  <span>{{ $t('button.export') }}</span>
                </router-link>
              </div>
              <hr class="navbar-divider" />
              <router-link class="navbar-item" :to="{ name: 'profile' }">
                <span class="icon is-medium">
                  <i class="fas fa-user"></i>
                </span>
                {{ $t('title.profile') }}
              </router-link>
              <hr class="navbar-divider" />
              <a class="navbar-item" @click="onLogout">
                <span class="icon is-medium">
                  <i class="fas fa-power-off"></i>
                </span>
                {{ $t('button.logout') }}
              </a>
            </div>
          </div>

          <div class="navbar-item has-dropdown is-hoverable">
            <a
              role="button"
              class="navbar-burger-desktop is-hidden-mobile is-hidden-tablet-only"
              aria-label="menu"
              aria-expanded="false"
            >
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>

            <div class="navbar-dropdown is-right">
              <router-link class="navbar-item" :to="{ name: 'whoWeAre' }">{{
                $t('title.whoWeAre')
              }}</router-link>
              <router-link class="navbar-item" :to="{ name: 'onlineInternalAudit' }">{{
                $t('title.whatIsOnlineInternalAudit')
              }}</router-link>
              <router-link class="navbar-item" :to="{ name: 'catalog' }">{{
                $t('title.catalog')
              }}</router-link>
              <router-link class="navbar-item" :to="{ name: 'howToRun' }">{{
                $t('title.howToRun5Steps')
              }}</router-link>
              <router-link class="navbar-item" :to="{ name: 'definitions' }">{{
                $t('title.definitions')
              }}</router-link>
              <router-link class="navbar-item" :to="{ name: 'legalInformation' }">{{
                $t('title.legalInformation')
              }}</router-link>
              <hr class="navbar-divider" />
              <router-link class="navbar-item" :to="{ name: 'contact' }">{{
                $t('title.contact')
              }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { LOGOUT } from '../../store/actions.type'

export default {
  data () {
    return {
      isOpen: false,
      navbarMaxHeight: null
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'isAuthenticated', 'role']),
    isProcessGroupPointCompany () {
      return this.currentUser.companyId && this.role.processWithPoint
    }
  },
  mounted () {
    this.setNavbarHeight()
    window.addEventListener('resize', this.setNavbarHeight)
  },
  destroyed () {
    window.removeEventListener('resize', this.setNavbarHeight)
  },
  methods: {
    onLogout () {
      this.$store.dispatch(LOGOUT).then(() => this.$router.push({ name: 'home' }))
    },
    onClickProcess () {
      if (this.$route.name === 'process') {
        window.location.href = `/${this.$t('routes.process')}`
      } else {
        this.$router.push({ name: 'process', params: { step: 1 } })
      }
    },
    setNavbarHeight () {
      this.navbarMaxHeight = window.innerHeight - this.convertRemToPixels(3.25)
    },
    convertRemToPixels (rem) {
      return rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
    }
  }
}
</script>
<style scoped>
/* .dropdown-content {
  max-height: 13em;
  overflow: auto;
} */
</style>
